"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const react_router_1 = require("react-router");
const auth_1 = require("companion-app-components/flux/auth");
const datasets_1 = require("companion-app-components/flux/datasets");
const helper_1 = require("data/app/helper");
// Query Parameters
//   - granteeEmail
//   - new (is grantee email a new user - e.g. requires create)
//   - datasetId
//
// Case 1: User Exists
//   Case 1a: A User is Currently Signed-In and Is Same as Grantee
//     - Switch Datasets
//   Case 1b:
//     - Add sign-in variables to local-storage
//     Case 1b1: User is Signed In
//       - Logout (which will re-direct to sign-in afterwards)
//     Case 1a2: User is Not Signed In
//       - Redirect to '/' to force sign-in
// Case 2: User Needs to be Created
//   - Add create variables to local-storage
//   Case 2a: A user is Currently Signed In
//     - Logout (which will re-direct to sign-in afterwards)
//   Case 2b: A user is Not Signed In
//     - Redirect to '/' to force sign-in
const useQueryParams = () => {
    const location = (0, react_router_1.useLocation)();
    const searchParams = new URLSearchParams(location.search);
    return {
        datasetId: searchParams.get('datasetId') || undefined,
        granteeEmail: searchParams.get('granteeEmail') || undefined,
        granteeId: searchParams.get('granteeId') || undefined,
    };
};
const useShareAccept = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const urlQuery = useQueryParams();
    const isAuthenticated = (0, react_redux_1.useSelector)(auth_1.authSelectors.isAuthenticated);
    const authQcsId = (0, react_redux_1.useSelector)(auth_1.authSelectors.getQCSId);
    const datasetsById = (0, react_redux_1.useSelector)(datasets_1.datasetsSelectors.getResourcesById);
    const startNewSignInOrSignUp = (0, react_1.useCallback)(() => {
        // Note: action must cause a hard refresh to reload the AuthDialog component
        if (isAuthenticated) {
            // Case 1b1 or 2a: User is signed-in, so logout to start new sign-in process
            dispatch(auth_1.authActions.authLogout({ reason: 'ACCEPT_SHARE' }, { context: 'dataset sharing' }));
        }
        else {
            // Case 1b2 or 2b: User is not signed-in, so just redirect to root page to start new sign-in process
            window.location.href = '/';
        }
    }, [dispatch, isAuthenticated]);
    (0, react_1.useEffect)(() => {
        const { datasetId, granteeEmail, granteeId } = urlQuery;
        if (granteeEmail && datasetId) {
            if (granteeId) {
                // Case 1: User Exists
                if (granteeId && isAuthenticated && granteeId === authQcsId) {
                    // Case 1a: A User is Currently Signed-In and Is Same as Grantee
                    const sharedDataset = datasetsById.get(datasetId);
                    if (sharedDataset) {
                        dispatch(auth_1.authActions.authSelectDataset(auth_1.authTypes.AuthSelectDatasetPayload({ dataset: sharedDataset })));
                    }
                    else {
                        // TODO: What to do about this corner case?
                    }
                }
                else {
                    // Case 1b: User is not authenticated or user is different from authenticated user
                    (0, helper_1.setDatasetShareAcceptData)((0, helper_1.mkDatasetShareAcceptData)({ granteeEmail: decodeURIComponent(granteeEmail), datasetId }));
                    startNewSignInOrSignUp();
                }
            }
            else {
                // Case 2: User needs to be created
                (0, helper_1.setDatasetShareAcceptData)((0, helper_1.mkDatasetShareAcceptData)({
                    isGranteeNewUser: true,
                    granteeEmail: decodeURIComponent(granteeEmail),
                    datasetId,
                }));
                startNewSignInOrSignUp();
            }
        }
        else {
            // TODO: What to do about this corner case?
        }
    }, [urlQuery, datasetsById, isAuthenticated, authQcsId, startNewSignInOrSignUp, dispatch]);
};
exports.default = useShareAccept;
